import config from '@/config'
import { Route } from '@/contracts/core/api/entity/Route'

/** Маршруты модуля share: работать ли без сервера, решает настройка модуля в src/config.ts */
export abstract class ShareRoute<P, T> extends Route<P, T> {
  isOffline(): boolean {
    return config.systemModules.share.offline === 'true'
  }
}
